module.exports = __webpack_public_path__ + "static/media/dollar-idea.74c62d33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dollar-idea.svg
// module id = 1184
// module chunks = 0